/* Scroll to #section after pictures finish loading, so the jump lands in the right place */
(function () {
  if (!location.hash || location.hash.length < 2) return;
  var id = decodeURIComponent(location.hash.slice(1));
  function jump() { var el = document.getElementById(id); if (el) el.scrollIntoView({ block: 'start' }); }
  window.addEventListener('load', function () { jump(); setTimeout(jump, 400); });
})();
